import { render } from "./EnrollmentGroup.vue?vue&type=template&id=01ec8dd0&scoped=true&ts=true"
import script from "./EnrollmentGroup.vue?vue&type=script&lang=ts"
export * from "./EnrollmentGroup.vue?vue&type=script&lang=ts"

import "./EnrollmentGroup.vue?vue&type=style&index=0&id=01ec8dd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ec8dd0"]])

export default __exports__